import { CloseOutlined } from '@ant-design/icons'
import { Drawer } from 'antd'
import React from 'react'
import './form-drawer.scss'

interface FormDrawerProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  child: any
  isOpen: boolean
  onClose?: () => void
  title: string
  isProfilePage?: boolean
}
const FormDrawer: React.FC<FormDrawerProps> = ({
  onClose,
  isOpen,
  child,
  title,
  isProfilePage,
}) => {
  const isMobile = window.innerWidth < 768
  return (
    <Drawer
      closable={false}
      onClose={onClose}
      open={isOpen}
      key={'right'}
      width={isMobile ? '100%' : '750'}
      destroyOnClose={true}
      maskClosable={true}
      className="drawer-container drop-shadow-lg peer-support-drawer"
    >
      <div
        className={`flex flex-row justify-between items-center mb-4 text-theme-blue drawer-header ${
          isProfilePage ? 'pl-6' : ''
        }`}
      >
        <div
          className={`font-medium font-lora ${
            isProfilePage ? 'text-2xl' : 'text-3xl'
          }`}
        >
          {title}
        </div>
        <CloseOutlined
          className="cursor-pointer text-black text-lg "
          onClick={onClose}
        />
      </div>
      {child}
    </Drawer>
  )
}

export default FormDrawer
